// @flow
import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MediaQueryProvider } from 'react-media-query-hoc';

import Users from './Pages/Users';
import Charities from './Pages/Charities';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';

import ScrollToTop from './Helpers/ScrollToTop';

import './App.css';
import './Form.css';
import './Typo.css';

// $FlowFixMe
firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "donatedoughnut.firebaseapp.com",
  databaseURL: "https://donatedoughnut.firebaseio.com",
  projectId: "donatedoughnut",
  storageBucket: "donatedoughnut.appspot.com",
  messagingSenderId: "1093322784016"
});

export default function (props) {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop>
          <MediaQueryProvider>
            <Header/>
            <Switch>
              <Route exact path="/" component={Users}/>
              <Route exact path="/charities" component={Charities}/>
            </Switch>
            <Footer/>
          </MediaQueryProvider>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/App.js